import dayjs from 'dayjs';
import { ChildDetailed, EditChildFormFields, ChildMealType } from 'types';
import { parseStringIntoDayjsTime } from 'utils/parsers/dateTime/parseStringIntoDayjsTime';
import { parseStringIntoDayjsDate } from '../dateTime/parseStringIntoDayjsDate';

export const parseChildIntoChildEditFormFields: (
    childData: ChildDetailed,
) => EditChildFormFields = (childData) => {
    const {
        firstName,
        lastName,
        pesel: peselNumber,
        sex,
        birthDate,
        birthPlace,
        address,
        groups,
        diseases,
        allergies,
        agreements,
    } = childData.child;

    const journalGroupId = groups.find(
        (group) => group.type === 'JOURNAL_GROUP' && !group.leftGroup,
    );

    let dietId: string | undefined;
    const selectedMeals: ChildMealType[] = [];

    if (childData.diet) {
        // Handle ChildDiet (has institutionDiet)
        if ('institutionDiet' in childData.diet && childData.diet.institutionDiet) {
            dietId = (childData.diet.institutionDiet as { id: string }).id;

            if ('breakfast' in childData.diet && childData.diet.breakfast) {
                selectedMeals.push('breakfast');
            }
            if ('soup' in childData.diet && childData.diet.soup) {
                selectedMeals.push('soup');
            }
            if ('dinner' in childData.diet && childData.diet.dinner) {
                selectedMeals.push('dinner');
            }
            if ('snack' in childData.diet && childData.diet.snack) {
                selectedMeals.push('snack');
            }
        } else if ('meals' in childData.diet && Array.isArray(childData.diet.meals)) {
            selectedMeals.push('breakfast', 'soup', 'dinner', 'snack');
        }
    }

    return {
        firstName,
        lastName,
        peselNumber: peselNumber || '',
        sex,
        birthDate: birthDate ? parseStringIntoDayjsDate(birthDate) : dayjs(),
        birthPlace: birthPlace || '',
        street: address?.street || '',
        city: address?.city || '',
        zipCode: address?.zipCode || '',
        groupName: journalGroupId?.id,
        declaredStayHoursFromTime: childData.settlementDetails?.stayStart
            ? parseStringIntoDayjsTime(childData.settlementDetails.stayStart)
            : null,
        declaredStayHoursToTime: childData.settlementDetails?.stayEnd
            ? parseStringIntoDayjsTime(childData.settlementDetails.stayEnd)
            : null,
        accountingPeriodStartDate: childData.settlementDetails?.periodStart
            ? parseStringIntoDayjsDate(childData.settlementDetails.periodStart)
            : null,
        accountingPeriodFinishDate: childData.settlementDetails?.periodEnd
            ? parseStringIntoDayjsDate(childData.settlementDetails.periodEnd)
            : null,
        description: childData.settlementDetails?.invoiceNotes || '',
        ...(dietId && { diet: dietId }),
        ...(selectedMeals.length > 0 && { selectMealsType: selectedMeals }),
        invoiceRecipientId: childData.settlementDetails?.invoiceRecipientId || null,
        dietFromDate:
            childData?.diet?.entries &&
            childData?.diet?.entries?.length > 0 &&
            // eslint-disable-next-line no-unsafe-optional-chaining
            childData.diet?.entries[childData?.diet?.entries?.length - 1].dateFrom
                ? parseStringIntoDayjsDate(
                      // eslint-disable-next-line no-unsafe-optional-chaining
                      childData.diet?.entries[childData?.diet?.entries?.length - 1].dateFrom,
                  )
                : null,
        diseases: diseases || '',
        allergens: allergies || '',
        socialNetworksImageSharingAgreementInstagram: agreements
            ? String(agreements.instagram)
            : '',
        socialNetworksImageSharingAgreementFacebook: agreements ? String(agreements.facebook) : '',
        socialNetworksImageSharingAgreementTikTok: agreements ? String(agreements.tiktok) : '',
        socialNetworksImageSharingAgreementWebsite: agreements ? String(agreements.website) : '',
    };
};
